module.exports = __webpack_public_path__ + "img/a-ziyuan17.08a349be.png";